import { EarningsPeriod } from '@api/api/earnings';
import { Entity } from '@api/api/entity-schema';

import { IndustryThemesTable } from './IndustryThemesTable';
import styles from './IndustryThemesTable.module.scss';
import { TopCompetitors } from './top-competitors/TopCompetitors';

export interface PeerComparisonProps {
  entity: Entity;
  activeReportingPeriod: EarningsPeriod;
}

export const PeerComparison = ({
  entity,
  activeReportingPeriod,
}: PeerComparisonProps) => {
  return (
    <div
      data-testid="peer-comparison-panel"
      className={styles.peerComparisonPanel}
    >
      <TopCompetitors
        entity={entity}
        activeReportingPeriod={activeReportingPeriod}
      />
      <IndustryThemesTable
        entity={entity}
        activeReportingPeriod={activeReportingPeriod}
      />
    </div>
  );
};
